export const defaultOnMouseDownHandler = (e: React.MouseEvent<any>) => {
  e.preventDefault();
  if (document.activeElement !== e.currentTarget){
    //@ts-ignore
    document?.activeElement?.blur();
  }
};
